import { ENV } from "./env";

export const API = {
  BASE_URL: ENV.API_BASE_URL,

  AUTH: {
    LOGIN: ENV.API_LOGIN,
    REGISTER: ENV.API_REGISTER,
    REFRESH: ENV.API_REFRESH,
    LOGOUT: ENV.API_LOGOUT,
    ME: ENV.API_ME,
    STATUS: ENV.API_STATUS,

    FORGOT_PASSWORD: ENV.API_FORGOT_PASSWORD,
    VERIFY_RESET_CODE: ENV.API_VERIFY_RESET_CODE,
    RESET_PASSWORD: ENV.API_RESET_PASSWORD,
  },

  MYACCOUNT_APP_URL: ENV.MYACCOUNT_APP_URL,
  MYPROFILE_APP_URL: ENV.MYPROFILE_APP_URL,
};